import React, { useState } from 'react';
import logoNav from '../../images/logo_finsus.png';

export const Banner = () => {
	return (

		<div className="hero">
			<div className="nav">
                <img src={logoNav} alt="Finsus logo" />
			</div>
			<div className="portada">
				<div className="informacion">
				</div>
			</div>
		</div>

		
	);
	
};
